<ng-template #historyModal let-modal>
    <div class="modal-header justify-content-start border-bottom">
        <h3 class="fw-semibold">Lịch sử trạng thái</h3>
        <app-button [class]="'btn btn-close btn-sm'" [spinner]="false" [id]="'login_modal_close_btn'"
            (click)="modal.dismiss()">
            <i class="ri-close-line"></i>
        </app-button>
    </div>
    <div class="modal-body address-form py-3 px-4">
        <div class="d-flex align-items-center w-100 gap-1">
            <div class="text-gray">
                <span>Trạng thái đơn hàng</span>
            </div>
            <div class="d-flex flex-column gap-2">
                <span class="d-flex align-items-center gap-1">
                    <ng-container *ngTemplateOutlet="
                template;
                context: { status: getOrderStatus(order.orderStatus) }
              "></ng-container>
                    <ng-template #template let-status="status">
                        <span class="dot {{
                  status.icon
                }} d-flex align-items-center justify-content-center"><span
                                class="inner-dot {{ status.icon }}"></span></span>
                        <span class="{{ status.icon }}">{{ status.value }}</span>
                    </ng-template>
                </span>
            </div>
        </div>
        <div class="d-flex align-items-center w-100 gap-1" style="padding-top: 12px;">
            <div class="text-gray">
                <span>Trạng thái thanh toán:</span>
            </div>
            <div class="d-flex flex-column gap-2">
                <span class="d-flex align-items-center gap-1">
                    <ng-container *ngTemplateOutlet="
              paymentStatusTemplate;
              context: { status: getPaymentStatus(order.paymentStatus) }
            ">
                    </ng-container>
                    <ng-template #paymentStatusTemplate let-status="status">
                        <span class="dot {{ status.icon }} d-flex align-items-center justify-content-center">
                            <span class="inner-dot {{ status.icon }}"></span>
                        </span>
                        <span class="{{ status.icon }}">{{ status.value }}</span>
                    </ng-template>
                </span>
            </div>
        </div>
        <div class="pt-3 px-2">
            <app-history-status [data]="historyStatusList" [orderStatus]="order.orderStatus"></app-history-status>
        </div>
    </div>
</ng-template>
